import React, { useEffect, useState } from 'react';
import { Button, Space, Steps, Modal, Collapse, message } from 'antd';
import { getFlowNodeReq, initiateApprovalReq, saveReq, getFlowIdReq } from './submit';
import style from './index.module.scss'

const { Step } = Steps;
const { Panel } = Collapse;
export const GrtWorkFlowSubmit = (props) => {
  const { pageId, refresh, formInstance } = props;
  // 获取流程id
  const [flowId, setFlowId] = useState('');
  const getFlowId = async () => {
    const res = await getFlowIdReq(pageId)
    setFlowId(res.data.flow_id);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  //点击提交获取提交列表
  const [approvalNodes, setApprovalNodes] = useState([]);
  const handleClickSubmit = () => {
    formInstance.formRef.current.validateFields().then(() => {
      setIsModalVisible(true);
      getFlowNodeReq({ flow_config_id: flowId }).then((res) => {
        if (res.code === '00000') {
          setApprovalNodes(res.data);
        }
      });
    });
  };
  //提交按钮
  const handleOk = () => {
    const formData = formInstance.formRef.current.getFieldsValue(true);
    const data = {
      id: formData.id,
      application_name: formData.application_name,
      task: JSON.stringify(formData),
      task_type: formData.task_type,
      state: '0'
    },
      json = {
        flow_config_id: flowId,
        form_data: JSON.stringify(data)
      };

    initiateApprovalReq(json).then((res) => {
      if (res.code === '00000') {
        setIsModalVisible(false);
        message.success('提交成功');
        refresh()
      }
    });
  };
  //保存
  const save = () => {
    console.log(formInstance)
    formInstance.formRef.current.validateFields().then(() => {
      const formData = formInstance.formRef.current.getFieldsValue(true);
      const data = {
        id: formData.id,
        application_name: formData.application_name,
        task: JSON.stringify(formData),
        task_type: formData.task_type,
        state: '-1'
      },
        json = {
          flow_config_id: flowId,
          form_data: JSON.stringify(data)
        };
      saveReq(json).then((res) => {
        if (res.code === '00000') {
          message.success('保存成功');
          setIsModalVisible(false);
          refresh()
        }
      });
    });
  };

  useEffect(() => {
    if (pageId) getFlowId()

  }), [pageId];

  return (
    <>

      <div>
        <Space>
          <Button type="primary" onClick={handleClickSubmit}>
            提交
          </Button>
          <Button type="primary" onClick={save}>
            保存
          </Button>
        </Space>
      </div>

      <Modal
        title="提交"
        visible={isModalVisible}
        onOk={handleOk}
        cancelText="取消"
        okText="确认"
        onCancel={() => setIsModalVisible(false)}
      >
        <Steps progressDot current={approvalNodes.length} direction="vertical">
          {approvalNodes.map((v) => {
            return (
              <Step
                key={v.node_id}
                title={
                  <Collapse defaultActiveKey={[v.node_id]} expandIconPosition="end" ghost>
                    <Panel header={<p className={style['title']}>{v.node_name}</p>} key={v.node_id}>
                      {v.approvers && v.approvers.length
                        ? v.approvers.map((vs) => (
                          <div key={vs.approver_id}>
                            <div className={style['content']}>
                              <img
                                src={
                                  vs.approver_img
                                    ? vs.approver_img
                                    : 'https://img2.baidu.com/it/u=85996889,2750756434&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1666717200&t=9f12084a87c42ec9719dc081eeabfe45'
                                }
                                alt=""
                              />
                              <div>{vs.approver_name}</div>
                            </div>
                          </div>
                        ))
                        : null}
                    </Panel>
                  </Collapse>
                }
              />
            );
          })}
        </Steps>
      </Modal>
    </>
  )
};

